import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { addPurchasedTomatoes } from '../utils/tomatoManagerV2';
import TomatoRefillTimer from './TomatoRefillTimer';

function TomatoRefillModal({ isOpen, onClose }) {
  const { currentUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  
  console.log('TomatoRefillModal rendered with props:', { isOpen, currentUser: currentUser?.uid });

  const tomatoPacks = [
    { id: 'pack_10', amount: 10, price: '$0.99', popular: false },
    { id: 'pack_50', amount: 50, price: '$3.99', popular: true },
    { id: 'pack_100', amount: 100, price: '$6.99', popular: false },
    { id: 'pack_500', amount: 500, price: '$24.99', popular: false }
  ];

  const handleWatchAd = async () => {
    setIsLoading(true);
    
    // Simulate watching an ad (in production, integrate with ad provider)
    setTimeout(() => {
      // Give 5 free tomatoes for watching an ad
      const userId = currentUser?.uid || 'anonymous_user';
      addPurchasedTomatoes(userId, 5);
      
      // Show success message
      alert('You earned 5 free tomatoes! 🍅');
      
      setIsLoading(false);
      onClose();
    }, 3000); // Simulate 3 second ad
  };

  const handlePurchase = async (pack) => {
    setIsLoading(true);
    
    try {
      // In production, integrate with payment provider (Stripe, PayPal, etc.)
      // For now, simulate purchase
      console.log(`Purchasing ${pack.amount} tomatoes for ${pack.price}`);
      
      // Simulate API call
      setTimeout(() => {
        // Add purchased tomatoes
        const userId = currentUser?.uid || 'anonymous_user';
        addPurchasedTomatoes(userId, pack.amount);
        
        // Show success message
        alert(`Purchase successful! ${pack.amount} tomatoes added to your account! 🍅`);
        
        setIsLoading(false);
        onClose();
      }, 1500);
    } catch (error) {
      console.error('Purchase error:', error);
      alert('Purchase failed. Please try again.');
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  console.log('TomatoRefillModal rendering with isOpen:', isOpen);

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100000,
        padding: '20px'
      }}
      onClick={(e) => {
        console.log('TomatoRefillModal overlay clicked');
        if (e.target === e.currentTarget) {
          console.log('Clicked outside modal content, closing modal');
          onClose();
        }
      }}
    >
      <div style={{
        backgroundColor: 'white',
        borderRadius: '20px',
        width: '100%',
        maxWidth: '450px',
        maxHeight: '90vh',
        overflow: 'auto',
        position: 'relative',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
        border: '3px solid red' // DEBUG: Make modal content visible
      }}>
        {/* Header */}
        <div style={{
          background: 'linear-gradient(135deg, #FF6B00 0%, #FF8E53 100%)',
          padding: '30px 20px',
          borderRadius: '20px 20px 0 0',
          textAlign: 'center',
          position: 'relative'
        }}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '15px',
              right: '15px',
              background: 'rgba(255, 255, 255, 0.2)',
              border: 'none',
              borderRadius: '50%',
              width: '30px',
              height: '30px',
              cursor: 'pointer',
              color: 'white',
              fontSize: '18px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            ×
          </button>
          
          <div style={{ fontSize: '48px', marginBottom: '10px' }}>🍅</div>
          <h2 style={{
            color: 'white',
            fontSize: '24px',
            margin: '0 0 10px 0',
            fontWeight: '700'
          }}>
            Out of Tomatoes!
          </h2>
          <p style={{
            color: 'rgba(255, 255, 255, 0.9)',
            fontSize: '16px',
            margin: 0
          }}>
            Get more tomatoes to keep throwing!
          </p>
        </div>

        {/* Content */}
        <div style={{ padding: '20px' }}>
          {/* Daily Refill Timer */}
          <TomatoRefillTimer />
          
          {/* Watch Ad Option */}
          <div style={{
            background: 'linear-gradient(135deg, #4CAF50 0%, #66BB6A 100%)',
            borderRadius: '15px',
            padding: '20px',
            marginBottom: '25px',
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'transform 0.2s ease',
            position: 'relative',
            overflow: 'hidden'
          }}
          onClick={handleWatchAd}
          onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
          onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            <div style={{
              position: 'absolute',
              top: '5px',
              right: '10px',
              background: '#FFD700',
              color: '#333',
              fontSize: '12px',
              padding: '3px 8px',
              borderRadius: '10px',
              fontWeight: '600'
            }}>
              FREE
            </div>
            <h3 style={{
              color: 'white',
              fontSize: '20px',
              margin: '0 0 8px 0'
            }}>
              Watch an Ad
            </h3>
            <p style={{
              color: 'rgba(255, 255, 255, 0.9)',
              fontSize: '16px',
              margin: 0
            }}>
              Get 5 Free Tomatoes! 🎬
            </p>
          </div>

          {/* Divider */}
          <div style={{
            textAlign: 'center',
            margin: '20px 0',
            position: 'relative'
          }}>
            <div style={{
              position: 'absolute',
              top: '50%',
              left: 0,
              right: 0,
              height: '1px',
              backgroundColor: '#e0e0e0'
            }}></div>
            <span style={{
              background: 'white',
              padding: '0 15px',
              position: 'relative',
              color: '#666',
              fontSize: '14px'
            }}>
              OR BUY TOMATO PACKS
            </span>
          </div>

          {/* Tomato Packs */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: '15px',
            marginBottom: '20px'
          }}>
            {tomatoPacks.map(pack => (
              <div
                key={pack.id}
                style={{
                  border: '2px solid',
                  borderColor: pack.popular ? '#FF6B00' : '#e0e0e0',
                  borderRadius: '15px',
                  padding: '15px',
                  textAlign: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  position: 'relative',
                  background: pack.popular ? 'rgba(255, 107, 0, 0.05)' : 'white'
                }}
                onClick={() => handlePurchase(pack)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'scale(1.05)';
                  e.currentTarget.style.borderColor = '#FF6B00';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'scale(1)';
                  e.currentTarget.style.borderColor = pack.popular ? '#FF6B00' : '#e0e0e0';
                }}
              >
                {pack.popular && (
                  <div style={{
                    position: 'absolute',
                    top: '-10px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    background: '#FF6B00',
                    color: 'white',
                    fontSize: '11px',
                    padding: '3px 10px',
                    borderRadius: '10px',
                    fontWeight: '600'
                  }}>
                    POPULAR
                  </div>
                )}
                <div style={{ fontSize: '24px', marginBottom: '5px' }}>🍅</div>
                <div style={{
                  fontSize: '20px',
                  fontWeight: '700',
                  color: '#333',
                  marginBottom: '5px'
                }}>
                  {pack.amount}
                </div>
                <div style={{
                  fontSize: '14px',
                  color: '#666',
                  marginBottom: '10px'
                }}>
                  Tomatoes
                </div>
                <div style={{
                  fontSize: '18px',
                  fontWeight: '700',
                  color: '#FF6B00'
                }}>
                  {pack.price}
                </div>
              </div>
            ))}
          </div>

          {/* Info */}
          <div style={{
            backgroundColor: '#f5f5f5',
            borderRadius: '10px',
            padding: '15px',
            textAlign: 'center',
            fontSize: '12px',
            color: '#666'
          }}>
            <p style={{ margin: '0 0 5px 0' }}>
              🍅 You get <strong>10 free tomatoes</strong> every day at midnight
            </p>
            <p style={{ margin: 0 }}>
              💳 Purchased tomatoes never expire
            </p>
          </div>
        </div>

        {/* Loading overlay */}
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: '20px'
          }}>
            <div style={{
              textAlign: 'center'
            }}>
              <div style={{
                width: '50px',
                height: '50px',
                border: '3px solid #f0f0f0',
                borderTop: '3px solid #FF6B00',
                borderRadius: '50%',
                margin: '0 auto 20px',
                animation: 'spin 1s linear infinite'
              }}></div>
              <p style={{ color: '#666' }}>Processing...</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TomatoRefillModal;